import { Route, Switch } from 'react-router-dom';

import VaccineIndex from './index';

import { Error404 } from '$HVUI';

const App = () => {
    const appleURL = '/v/vaccine-card/';
    const googleURL = '/v/vaccine-pass/';
    return (
        <Switch>
            <Route
                exact
                path={`${appleURL}:token(.{8}-.{4}-.{4}-.{4}-.{12})`}
                component={props => (
                    <VaccineIndex {...props} />
                )}
            />
            <Route
                exact
                path={`${googleURL}:token(.{8}-.{4}-.{4}-.{4}-.{12})`}
                component={props => (
                    <VaccineIndex {...props} />
                )}
            />
            <Route component={Error404} />
        </Switch>
    );
};
export default App;
